<template>
  <tree-transfer
    ref="treeTransfer"
    :title="title"
    root-pid-value="0"
    pid="parentId"
    check-strictly-type="modular"
    check-strictly
    :from_data="fromData"
    :to_data="toData"
    :default-props="{ label: 'label' }"
    mode="transfer"
    highlight-current
    check-on-click-node
    height="100%"
    filter
    open-all
    draggable
    :expand-on-click-node="false"
    :allow-drop="allowDrop"
    @node-drag-start="nodeDragStart"
    @add-btn="add"
    @remove-btn="remove"
    @left-check-change="leftCheckChange"
  >
    <span slot="content-left" slot-scope="{ node, data }" :class="{ 'none-tree': !node.label }">
      <i v-if="data.nodeType === 'SPACE'" class="iconfont icon-kongjian1" :style="`color:${variables.main};font-size:13px;`"></i>
      <i v-if="data.nodeType === 'DEVICE'" class="iconfont icon-shebei1" style="color:#feb37e;font-size: 12px;"></i>
      {{ node.label }}
    </span>
    <span slot="content-right" slot-scope="{ node, data }" :class="{ 'none-tree': !node.label }">
      <i v-if="data.nodeType === 'SPACE'" class="iconfont icon-kongjian1" :style="`color:${variables.main};font-size:13px;`"></i>
      <i v-if="data.nodeType === 'DEVICE'" class="iconfont icon-shebei1" style="color:#feb37e;font-size: 12px;"></i>
      {{ node.label }}
    </span>
  </tree-transfer>
</template>

<script>
import variables from '@klinx/components/packages/styles/variables.module.scss';
export default {
  name: 'SpaceTreeTransfer',
  components: { treeTransfer: resolve => require(['el-tree-transfer'], resolve) },
  props: {
    title: {
      type: Array,
      default() {
        [];
      }
    },
    // 右侧默认数据
    defaultToData: {
      type: Array,
      default() {
        [];
      }
    },
    // 左侧默认数据
    defaultFromData: {
      type: Array,
      default() {
        [];
      }
    }
  },
  data() {
    return {
      fromData: [],
      toData: [],
      type: '',
      handle: false,
      variables
    };
  },
  watch: {
    toData: {
      handler() {
        this.$emit('getToData', this.toData);
      },
      deep: true
    },
    defaultToData: {
      handler(val) {
        if (!this.handle) {
          this.toData = val;
        }
      },
      immediate: true,
      deep: true
    },
    defaultFromData: {
      handler(val) {
        this.fromData = this.treeFilter(val, this.func);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 树结构筛选，筛选掉默认勾选的
    treeFilter(tree, func) {
      // 使用map复制一下节点，避免修改到原树
      return tree
        .map(node => ({ ...node }))
        .filter(node => {
          node.children = node.children && this.treeFilter(node.children, func);
          return func(node) || (node.children && node.children.length);
        });
    },
    func(node) {
      return !this.defaultToData.find(v => v.id === node.id);
    },
    // 左侧全选
    leftCheckChange(nodeObj, treeObj, checkAll) {
      if (checkAll) {
        this.handle = true;
        const list = this.treeToList(this.defaultFromData).filter(v => {
          return v.disabled !== true;
        });
        const arr = list.map(v => v.id);
        this.$refs.treeTransfer.setChecked(arr);
      }
    },
    // 监听穿梭框组件添加
    add(fromData, toData, obj) {
      const addList = obj.nodes.filter(v => !this.toData.some(ele => ele.id === v.id));
      this.toData = [...this.toData, ...addList];
      this.toData = this.toData.map(v => {
        return {
          ...v,
          children: null
        };
      });
    },
    // 树转数组
    treeToList(tree) {
      let result = tree.map(node => {
        node.level = 1;
        return node;
      });
      for (let i = 0; i < result.length; i++) {
        if (!result[i].children) continue;
        const list = result[i].children.map(node => {
          node.level = result[i].level + 1;
          return node;
        });
        result.splice(i + 1, 0, ...list);
      }
      result = result.map(v => {
        return {
          ...v
        };
      });
      return result;
    },
    // 监听穿梭框组件移除
    remove(fromData, toData, obj) {},
    nodeDragStart(type) {
      this.type = type;
    },
    allowDrop(draggingNode, dropNode, type) {
      if (this.type === 'right' && draggingNode.level === dropNode.level) {
        // 向上拖拽 || 向下拖拽
        return type === 'prev' || type === 'next';
      } else {
        // 不同级进行处理
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .transfer-title {
    .el-checkbox__input {
      position: relative;
      top: -2px;
    }
  }
  .el-tree-node__content {
    .custom-tree-node {
      position: relative;
      top: -1px;
    }
  }
}
</style>
